<template>
  <div class="memberService">
          <div style="width: 100%;padding: 40px 0;">
        <div class="healthInnovation" id="medacalCombo">
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
          <div class="service-border" style="margin: 0;">
            <img src="../../assets/images/medcialService/health/normal_u585.svg" alt="">
          </div>
          <div class="smartHealth-title medcialService-title">
            <p >{{$t('medicialHealth.smart_titlle03')}}</p>
            <p>{{$t('medicialHealth.smart_titlle04')}}</p>
          </div>
        </div>
        <div class="smartHealth-msg medcialService-msg">
          <section>
            {{$t('medicialHealth.samrt_text02')}}
          </section>
        </div>
        <div class="facility-item">
          <div class="img-box">
            <div class="img-title">睡眠监测</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_01.png" alt="">
          </div>
          <div class="img-box">
            <div class="img-title">血压监测</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_02.png" alt="">
          </div>
        </div>
        <div class="facility-item">
          <div class="img-box">
            <div class="img-title">血氧、心率监测</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_03.png" alt="">
          </div>
          <div class="img-box">
            <div class="img-title">心音、肺音远程听诊</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_04.png" alt="">
          </div>
        </div>
        <div class="facility-item">
          <div class="img-box">
            <div class="img-title">血压、血氧、血糖、心电、体温、呼吸率一机监测</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_05.png" alt="">
          </div>
          <div class="img-box">
            <div class="img-title">心电监测</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_06.png" alt="">
          </div>
        </div>
        <div class="facility-item">
          <div class="img-box">
            <div class="img-title">二便常规居家监测</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_07.png" alt="">
          </div>
          <div class="img-box">
            <div class="img-title">智能魔镜</div>
            <img src="https://files.shareonhealth.com/xuanhe-portal/activity/facility_08.png" alt="">
          </div>
        </div>
        <!-- <div class="electronics-info" v-for="(item,index) in footerList" :key="index">
          <div class="product-box">
            <img :src="item.iconUrl" alt="">
            <div class="product">{{item.itemName}}</div>
          </div>
          <div class="hint-box">
            <div class="smartHealth-box">
              <div class="box-item" :style="item.isVideo && !MobileVerification? 'border-radius: 8px 0 0 8px;' : ''" v-for="(int,ind) in item.children" :key="ind">
                  <div class="product-head">
                    <div class="product-hint">
                      {{item.itemDesc}}
                    </div>
                  </div>
                  <div class="product-footer">
                    <img :src="int.fileUrl" alt="">
                  </div>
              </div>
            </div>
            <div class="smartHealth-right">
    
              <div class="video-box" :style="!MobileVerification ? 'border-radius: 0 8px 8px 0;' : 'border-radius: 8px;'" v-if="item.isVideo">
                <video src="../../assets/images/medcialService/innovate/mt.mp4"
                       controls>
                </video>
              </div>
              <div v-else>
                <ElectronicsVue :itemList="item.children"></ElectronicsVue>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      </div>
    <!-- <div class="box_item" style="padding: 20px 0 60px 0;" v-for="(item,index) in clientInfo" :key="index">
      <div class="member-box">
      <div class="service-border">
          <img src="../../assets/images/medcialService/health/normal_u585.svg" alt="">
        </div>
        <div class="medcialService-title">
          <p style="text-align: center;">{{ item.cardName }}</p>
        </div>
        <div class="head-box" v-if="index == 0">
          <div class="head-img" v-for="(int,ind) in headList" :key="ind" @click="goDetail(int)">
            <img :src="int.fileUrl" alt="">
          </div>
        </div>
      <div class="memberService-content" v-if="index == 1">
        <div class="memberService-main" v-if="MobileVerification">
          {{ item.cardDesc }}
        </div>
        <div class="memberService-img" style="background-image: linear-gradient(-180deg, #958eff 0%, #958eff 7.999999999999995%, #6136cf 97.99999999999996%, #6136cf 99.99999999999996%);">
          <img :src="item.fileUrl " alt="">
        </div>
        <div class="memberService-main" v-if="!MobileVerification">
          {{ item.cardDesc }}
        </div>
      </div>
      <el-collapse v-if="index == 1">
        <el-collapse-item>
          <template slot="title">
            <div class="box-title">
              <img class="svg-icon" :src="`https://files.shareonhealth.com/xuanhe-portal/activity/physical.svg`"  alt="">
              <p class="common">套餐详情</p>
            </div>        
          </template>
          <el-table
            :data="item.detailList"
            border
            style="width: 100%;">
          <el-table-column
              prop="serviceItem"
              label="服务项目"
              align="center"
              width="180">
          </el-table-column>
          <el-table-column
              prop="serviceContent"
              align="left"
              label="服务内容">
          </el-table-column>
        </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    </div> -->
    <div style="width: 100%;padding: 40px 0"  v-if="!MobileVerification">
          <div class="head-box" style="flex-direction: column;">
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
          <div class="service-border" style="margin: 0;">
            <img src="../../assets/images/medcialService/health/normal_u585.svg" alt="">
          </div>
          <div class="smartHealth-title medcialService-title">
            <p >{{$t('medicialHealth.smart_titlle07')}}</p>
          </div>
        </div>
          <div class="smartHealth-combo" >
            <div class="img-info-box">
              <div class="img-info-item">
                <div class="header-item" style="display: flex;">
                  <i style="color:#c2353f;margin-right: 36px;font-size: 42px;" class="contact-icon am-icon-phone"></i>
                  <div class="item">
                    <strong style="font-size: 36px;">021-5808-9909</strong>
                    <div style="font-size: 16px;">{{$t('head.hotWire')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
    </div>
  </div>
</template>

<script>
import {getRequest} from "@/api/api";
import { EventBus } from '../../utils/enevt-bus';
export default {
    name:'memberService',
    
    data() {
    return {
      dialogTableVisible:false,
      tableData: [{
        serviceItem: '年度体检',
        serviceContent: '私人定制年度体检计划，高端医疗机构年度体检一次，专业医生检前问诊，根据个体情况个性化定制体检项目（加项另外收费），面对面解读体检报告',
      }, {
        serviceItem: '家庭医生',
        serviceContent: '配备1位专属家庭医生，制定全家人健康管理方案，通过可穿戴健康设备，实时采集跟踪健康数据，给予健康指导及疾病治疗',
      }, {
        serviceItem: '专科医生',
        serviceContent: '配备心内科、神经内科、呼吸科、内分泌科、消化科、妇科、中医科等专科医生，负责疾病的诊治 ',
      }, {
        serviceItem: '健康管家',
        serviceContent: '配备1位专属健康管家，制定家庭成员个性化健康管理方案，定期跟踪随访，复查提醒、用药提醒等',
      }, {
        serviceItem: '三甲绿通',
        serviceContent: '协助预约沪上各大三甲医院专家（指定专家或家庭医生推荐专家），三天内实现就诊（诊费及相关检查费用另外支付）',
      }, {
        serviceItem: '在线咨询',
        serviceContent: '7*8H在线守护，包括图文问诊，健康咨询、用药指导等',
      }, {
        serviceItem: '居家服务',
        serviceContent: '护理人员定期上门，为您和家人测量血压、血脂、伤口换药等，必要时提供上门采血、上门送药等服务',
      }, {
        serviceItem: '穿戴设备',
        serviceContent: '配备个人可穿戴设备，采集动态健康数据并时时上传，协助医生动态掌握您的健康状况',
      }, {
        serviceItem: '家庭药箱',
        serviceContent: '配备家庭药箱，提供家庭必须医疗用品（含常备基础应急用品十余种），OTC药物3种，定期上门更新药箱',
      }, {
        serviceItem: '核磁检查',
        serviceContent: '头颅血管磁共振检测',
      }, {
        serviceItem: '专车接送',
        serviceContent: '专车司机接送就诊，保您全程无驾车烦忧',
      }, {
        serviceItem: '折扣优惠',
        serviceContent: '享受玄合元门诊部就诊折扣',
      }
      ],
      clientInfo:[],
      imgUrl:process.env.VUE_APP_IMG_BASE_URL,
      language:'',
      headList:[
       {
        fileUrl:'https://files.shareonhealth.com/xuanhe-portal/insurance/head_01.png',
        title:'个人卡',
        ImgList:{
            img:[
            'https://files.shareonhealth.com/xuanhe-portal/insurance/card-11.png',
            ]
        },
       },
       {
        fileUrl:'https://files.shareonhealth.com/xuanhe-portal/insurance/head_02.png',
        title:'至尊家庭卡',
        ImgList:{
            img:[
            'https://files.shareonhealth.com/xuanhe-portal/insurance/card-12.png',
            ]
        },
       },
       {
        fileUrl:'https://files.shareonhealth.com/xuanhe-portal/insurance/head_03.png',
        title:'安宜家庭卡',
        ImgList:{
            img:[
            'https://files.shareonhealth.com/xuanhe-portal/insurance/card-13.png',
            ]
        },
       },
       {
        fileUrl:'https://files.shareonhealth.com/xuanhe-portal/insurance/head_04.png',
        title:'基础家庭卡',
        ImgList:{
            img:[
            'https://files.shareonhealth.com/xuanhe-portal/insurance/card-21.png',
            ]
        },
       },
       {
        fileUrl:'https://files.shareonhealth.com/xuanhe-portal/insurance/head_05.png',
        title:'精英家庭卡',
        ImgList:{
            img:[
            'https://files.shareonhealth.com/xuanhe-portal/insurance/card-22.png',
            ]
        },
       },
       {
        fileUrl:'https://files.shareonhealth.com/xuanhe-portal/insurance/head_06.png',
        title:'至尊家庭卡',
        ImgList:{
            img:[
            'https://files.shareonhealth.com/xuanhe-portal/insurance/card-23.png',
            ]
        },
       },
      ],
      footerList:[
        {
            iconUrl:require('../../assets/images/medcialService/innovate/mt.svg'),
            itemName:'智能马桶',
            itemDesc:'二类医疗器械认证\n' +
                '不去医院，在家就能做体检\n' +
                '30项健康指标，提示多种健康风险',
            isVideo:true,
            children:[
                {
                  fileUrl: require('../../assets/images/medcialService/innovate/mt.jpg'),
                  children:[
                      {
                        title:'血压监测2',
                        text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
                        fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
                      },
                      {
                        title:'血压监测3',
                        text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
                        fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
                      },
                      {
                        title:'血压监测4',
                        text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
                        fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
                      },
                      {
                        title:'血压监测5',
                        text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
                        fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
                      },
                  ]
                }
            ]
          },
          {
            iconUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/bloodpressure.svg`,
            itemName:'智能手表',
            itemDesc:'专利双气囊设计\n' +
                '二类医疗器械认证\n' +
                '随时随地测量和管理您的健康',
            children:[
                {
                  fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/monitor-one.jpg`,
                  children:[
                    {
                      title:'血压监测',
                      flag:'2',
                      text:'结合示波法微气囊和血氧心率双功能PPG光电感应，帮助您随时随地迅速了解血压状况。比传统血压计更精巧，轻便。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/monitor-one.png`
                    },
                    {
                      title:'心率监测',
                      flag:'1',
                      remake:'* 人每一次脉搏的搏动，都代表一次有效的心脏跳动，每分钟心脏跳动的次数就是心率。',
                      text:'无感佩戴下，24小时全天候监测心率。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/monitor4.png`
                    },
                    {
                      title:'心率变异性（HRV）',
                      flag:'1',
                      ispad:'1',
                      text:'健康的心脏拥有健康的“不规律性”，HRV测的就是心跳的不规律性。心跳的不规律性是由自主神经主导的；因此，HRV能够反映神经系统的健康。通常来说HRV越高越好。高HRV代表更好的心血管功能和抗压能力，而低HRV意味着更高的焦虑抑郁风险，以及更高的心血管痪病的死亡率。压力过大、情绪波动、睡眠不良、某些药物和食物，都可能降低HRV。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/monitor5.jpg`
                    },
                    {
                      title:'睡眠监测',
                      flag:'4',
                      ispad:'3',
                      text:'通过精密的算法和硬件的支持，对睡眠中：深睡眠 浅睡眠和清醒时间的记录和分析，从而对整体睡眠质量进行全方位的评估。',
                      remake:'* 睡眠被剥夺的影响可通过多种方式表现出来。除了明显表现出的疲劳和烦躁感外，睡眠不足还会导致体重上升、情绪波动和心脏病风险增加。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/monitor7.png`
                    },
                    {
                      title:'血氧监测',
                      flag:'3',
                      ispad:'2',
                      text:'血氧饱和度，是血液中血氧的浓度，通常用来反映人们呼吸循环以及供氧状况。血氧低就是缺氧,常见症状头晕易困,做事提不起精神,易暴怒急躁。血氧水平在95%到100%之间被认为是健康的，低于90%就得注意休息，血氧水平低于80%可能导致心脏和大脑功能受损。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/monitor6.png`
                    },
                  ]
                },
            ]
          },
          {
            iconUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/ring.svg`,
            itemName:'智能指环',
            itemDesc:'无感检测\n' +
                '医疗级准确度\n' +
                '最具创新的健康可穿戴设备',
            children:[
                {
                  fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/ring1.jpg`,
                  children:[
                    {
                      title:'睡眠管理',
                      text:'不仅提供无感佩戴的舒适体验，还能监测睡眠中的呼吸暂停综合症，并通过实时动态图表展示数据。它还能跟踪心率变异性、血氧水平、体温变化等生理指标，为用户提供全面的健康分析。此外，指环还可能配备智能提醒功能，提供个性化的健康建议和睡眠改善策略，甚至可以与其他健康管理设备同步数据，帮助用户更好地管理整体健康。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/ring2.jpg`
                    },
                    // {
                    //   title:'活动管理',
                    //   text:'方便运动佩戴、可在游泳时佩戴、科学管理卡路里和运动目标。',
                    //   fileUrl:require('../../assets/images/medcialService/innovate/ring4.jpg')
                    // },
                    {
                      title:'压力管理',
                      text:'全天压力管理、高压提醒、正念呼吸训练。对生命体征、活动和睡眠等指标长程监控，对异常状态告警提示并提供个性化健康建议。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/ring3.jpg`
                    },
                    {
                      title:'主动健康管理',
                      flag:'5',
                      text:'健康时间轴、做笔记和标签、健康建议、7天24小时连续数据。此外，指环可以与智能手机应用同步，提供详细的趋势分析和历史数据回顾。',
                      fileUrl:`${ process.env.VUE_APP_IMG_BASE_URL }/activity/ring4.jpg`
                    },
                  ]
                }
            ]
          },
          
          // {
          //   iconUrl:require('../../assets/images/medcialService/service/bloodpressure.svg'),
          //   itemName:'自动睡眠质量监测',
          //   itemDesc:'随时随地，全方位地测量和管理您的健康状态',
          //   children:[
          //       {
          //         title:'血压监测',
          //         text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
          //         fileUrl:require('../../assets/images/medcialService/service/yangbenku.png'),
          //         children:[
          //             {
          //               title:'血压监测2',
          //               text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
          //               fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
          //             },
          //             {
          //               title:'血压监测3',
          //               text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
          //               fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
          //             },
          //             {
          //               title:'血压监测4',
          //               text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
          //               fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
          //             },
          //             {
          //               title:'血压监测5',
          //               text:'有三十多年的外科临床工作经验，是我国最早一批开展腹腔镜手术的外科医生。能熟练开展腹腔镜胆囊切除术、腹腔镜胆总管切开取石术、腹腔镜肠切除术和腹腔镜疝修补术等。擅长处理肠瘘、严重腹腔感染、短肠综合征等腹腔疑难杂症。能熟练地给不能正常进食的病人提供肠内营养和肠外营养支持，为疾病治疗创造条件。',
          //               fileUrl:require('../../assets/images/medcialService/service/yangbenku.png')
          //             },
          //         ]
          //       }
          //   ]
          // },
        ],
    };
    
  },
  created() {
      EventBus.$on('globalComponentChanged', this.handleGlobalComponentChange);
  },
  watch: {
		MobileVerification: {
			handler(to) {
			//处理函数
				// this.isMobileVt();
			},
			immediate: true,
		},
	},
  mounted(){
    this.language = this.$i18n.locale
    this.getMemberData();
  },
  methods:{
    goDetail(item){
      if(item.ImgList){
        this.$router.push({
          name:'healthDetail',
          params:{
            list:item.ImgList,
            title:item.title
          }
        })
      }
    },
    handleGlobalComponentChange(data) {
        this.language = data.someData
        this.getMemberData()
      },
    getMemberData () {
      let headers = { 'Accept-Language': this.language === 'en' ? 'en_US' : 'zh_CN' }

      getRequest('/api/record/membersCard/list',{},headers).then((res) => {
        console.log('会员卡列表',res.data.data)
        this.clientInfo = res.data.data
      });
    },
    openModal(){
      console.log('打开弹窗')
    },
  }
}
</script>

<style scoped lang="less">
@media (max-width: 800px){
  .facility-item{
    padding: 0 12px !important;
  }
}
.facility-item{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  .img-box{
    width: 49.4%;
    height: auto;
    .img-title{
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      color: #0070C0;
      margin-bottom: 10px;
    }
  }
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.facility-item:nth-last-child(1){
  margin-bottom: 0;
}
.head-box{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: calc(100vw * 20 / 1920);
  .head-img{
    width: 32%;
    object-fit: cover;
    cursor: pointer;
    img{
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
}
.memberService{
  min-height: 700px;
}
.el-drawer__wrapper{
  z-index: 99999 !important;
}
.el-table{
  font-size: 20px;
  color: #000 !important;
}
.el-table thead{
  color: #000;
}
.service-border{
  display: flex;
  align-items: center;
  justify-content: center;
}
.medcialService-title{
  margin-bottom: 40px;
}
.box-title{
    width: 1240px;
    display: flex;
    align-items: center;
    padding-left: 20px;
    .common{
      font-size: 16px;
      font-family: "PingFangSC-Medium", "PingFang SC Medium", "PingFang SC", sans-serif;
      color: #333333;
    }
    .svg-icon{
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
</style>